module.exports = __webpack_public_path__ + "static/media/pin_green.312544d1.svg";